import "./index.scss";
import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { CarouselSlide } from "components/UI/atoms";
import { CarouselSelector } from "..";

export const Carousel = ({ slides }) => {
  const settings = {
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: false,
    draggable: false,
    pauseOnHover: false,
    swipeToSlide: false,
    useTransform: false
  };

  const [currentSlide, setSlide] = useState(0);
  const [transition, setTransition] = useState(false);

  let sliderRef = useRef(null);
  let transitionTimer = useRef(0);

  const handleSelectorHover = (index) => {
    clearTimeout(transitionTimer.current);
    setTransition(true);
    sliderRef.slickGoTo(index, true);
    transitionTimer.current = setTimeout(() => setTransition(false), 500);
  };

  return (
    <div className="carousel">
      <div className="carousel-slider">
        <Slider
          className={transition ? "transition" : ""}
          beforeChange={(_, newIndex) => setSlide(newIndex)}
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}
        >
          {slides.map((sliderProps) => (
            <CarouselSlide key={sliderProps.cta} {...sliderProps} />
          ))}
        </Slider>
        <div className="carousel-dots" data-testid="carousel-dots">
          {slides.map((_, index) => (
            <div
              key={index}
              className={currentSlide === index ? "dot active" : "dot"}
            />
          ))}
        </div>
      </div>
      <CarouselSelector
        slides={slides}
        currentSlide={currentSlide}
        onSelectorHover={handleSelectorHover}
      />
    </div>
  );
};
